// extracted by mini-css-extract-plugin
var _1 = "TableRowActions-moduleTableRowActions__fFC5b TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
export { _1 as "TableRowActions" }
